import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatChip } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'aionz-generic-purchase-request-dialog',
  standalone: true,
  imports: [
    MatIcon,
    MatButton,
    MatChip,
  ],
  templateUrl: './generic-purchase-request-dialog.component.html',
  styleUrl: './generic-purchase-request-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericPurchaseRequestDialogComponent {
  id = input<string>();
  title = input.required<string>();
  description = input.required<string>();
  requestedAt = input<Date>();
  declineButtonText = input<string>('Recusar');
  approveButtonText = input<string>('Aprovar Solicitação');
  showDeclineButton = input<boolean>(true);
  showApproveButton = input<boolean>(true);
  disableDeclineButton = input<boolean>(false);
  disableApproveButton = input<boolean>(false);

  onCancel = output<void>();
  onDecline = output<void>();
  onApprove = output<void>();
}
